import React from 'react';

import PropTypes from 'prop-types';
import { connect } from 'react-redux';

import {
    fetchCityGuideAction,
} from 'wanderu-ducks-seo';
import Widget from 'wanderu-widget';

import { generateLocaleAwareGuideId } from '../../utils';
import PlaceGuideContainer from '../PlaceGuide/PlaceGuide';

class CityGuideContainer extends React.Component {
    static async serverFetchData(opts) {
        const {
            dispatch,
            params,
        } = opts;

        const {
            region,
            city,
            locale,
            mode,
        } = params;

        const cityGuideId = generateLocaleAwareGuideId(params);

        await Promise.all([
            dispatch(fetchCityGuideAction.fetchCityGuide(cityGuideId, region, city, mode, locale)),
            Widget.serverFetchData(opts),
        ]);

        await PlaceGuideContainer.serverFetchData({ ...opts, placeId: cityGuideId });
    }

    async componentDidMount() {
        const {
            match,
            isLoaded,
            cityGuideId,
            fetchCityGuide,
        } = this.props;

        if (!isLoaded) {
            const {
                region,
                city,
                mode,
                locale,
            } = match.params;

            fetchCityGuide(cityGuideId, region, city, mode, locale);
        }
    }

    async componentDidUpdate(prevProps) {
        const {
            match,
            cityGuideId,
        } = this.props;
        const {
            cityGuideId: previousCityGuideId,
        } = prevProps;

        if (cityGuideId !== previousCityGuideId) {
            const queryParams = match.params;

            this.props.fetchCityGuide(
                cityGuideId,
                queryParams.region,
                queryParams.city,
                queryParams.mode,
                queryParams.locale,
            );
        }
    }

    render() {
        return (
            <PlaceGuideContainer
                {...this.props}
                placeGuideId={this.props.cityGuideId}
                showBreadcrumbs
                showCheapestTicket
                showInfoSection
                showInterlinkSection
                showMainStations
                showPopularRoutes
            />
        );
    }
}

CityGuideContainer.propTypes = {
    cityGuideId: PropTypes.string.isRequired,
    error: PropTypes.object,
    fetchCityGuide: PropTypes.func.isRequired,
    isFetching: PropTypes.bool.isRequired,
    isLoaded: PropTypes.bool.isRequired,
    locationData: PropTypes.shape({
        wcityid: PropTypes.string,
    }),
    match: PropTypes.shape({
        params: PropTypes.shape({
            city: PropTypes.string.isRequired,
            locale: PropTypes.string.isRequired,
            mode: PropTypes.string,
            region: PropTypes.string.isRequired,
        }).isRequired,
    }).isRequired,
    notFound: PropTypes.bool,
};

function mapStateToProps(state, ownProps) {
    const cityGuideId = generateLocaleAwareGuideId(ownProps.match.params);

    return {
        cityGuideId,
        error: fetchCityGuideAction.selectError(state, cityGuideId),
        isFetching: fetchCityGuideAction.selectWorking(state, cityGuideId),
        isLoaded: fetchCityGuideAction.selectSuccess(state, cityGuideId),
        notFound: fetchCityGuideAction.selectNotFound(state, cityGuideId),
    };
}

const mapDispatchToProps = {
    fetchCityGuide: fetchCityGuideAction.fetchCityGuide,
};

export {
    CityGuideContainer,
    mapStateToProps,
};

export default connect(mapStateToProps, mapDispatchToProps)(CityGuideContainer);
